<nav
  class="navbar navbar--dark navbar-expand-lg flex-row justify-content-between px-3 px-md-5">
  <a
    class="navbar__brand d-none d-lg-block"
    [routerLink]="['/workflow/work-items']">
    <div class="navbar__brand-logo pmt-logo"></div>
  </a>

  <div ngbDropdown class="navbar-toggler p-0">
    <button
      class="navbar-toggler p-0 border-0"
      type="button"
      ngbDropdownToggle
      aria-label="Main navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="dropdown-menu" ngbDropdownMenu>
      @for (route of routes; track route.path) {
        <a
          class="dropdown-item"
          [routerLink]="route.path"
          routerLinkActive="active">
          {{ route.data['title'] }}
        </a>
        @if (!$last) {
          <div class="dropdown-divider"></div>
        }
      }
    </div>
  </div>

  <div class="navbar-collapse collapse" id="navbarNav">
    <ul class="navbar-nav">
      @for (route of routes; track route.path) {
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="route.path">
            {{ route.data.title }}
          </a>
        </li>
      }
    </ul>
  </div>

  <div class="d-flex align-items-center ml-auto">
    @if (!!user) {
      <div class="nav-item nav-link menu-icon" title="Report generic QA issue">
        <app-work-items-qa-generic-entry></app-work-items-qa-generic-entry>
      </div>

      @if (!isProduction && !isStage) {
        <div class="nav-item nav-link menu-icon" title="Share feedback">
          <app-feedback-entry></app-feedback-entry>
        </div>
      }

      <div class="nav-item nav-link menu-icon" title="Notifications">
        <app-notifications-bell></app-notifications-bell>
      </div>
    }

    <ul class="navbar-nav navbar__settings d-flex flex-row">
      <li class="nav-item dropdown" ngbDropdown>
        <div
          class="user d-flex flex-row align-items-center"
          data-toggle="dropdown"
          ngbDropdownToggle>
          <div
            class="user__icon freshicon"
            [title]="
              user?.name +
              '\n' +
              user?.parentOrganization?.no +
              ' ' +
              user?.parentOrganization?.name
            "></div>
          <div
            class="d-none d-xl-flex flex-column justify-content-center ml-md-3">
            <div class="user__name">{{ user?.name }}</div>
            <div class="user__company__name">
              {{ user?.parentOrganization?.no }}
              {{ user?.parentOrganization?.name }}
            </div>
          </div>
          <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
            @if (!!user && !user.isExternal) {
              <a class="dropdown-item" (click)="help()">
                Help
                <span
                  class="k-font-icon k-i-hyperlink-open-sm"
                  aria-hidden="true"></span>
              </a>
              <div class="dropdown-divider"></div>
            }
            <a class="dropdown-item" (click)="logout()">Sign out</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item">
              {{ version }}
            </a>
          </div>
        </div>
      </li>
    </ul>
  </div>
</nav>

@if (!!childrenRoutes.length) {
  <nav
    class="navbar navbar--light navbar--sub-bar flex-row justify-content-between">
    <ul class="navbar-nav flex-row">
      @for (route of childrenRoutes; track route.path) {
        <li class="nav-item" routerLinkActive="active">
          <a
            class="nav-link"
            [routerLink]="[route.data['parent'], route.path]"
            [preserveFragment]="true">
            {{ route.data.title }}
          </a>
        </li>
      }
    </ul>
  </nav>
}
